var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.207,
    height: 19.207,
    viewBox: "0 0 19.207 19.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".font1,.content1{fill:none;stroke-linecap:round;stroke-miterlimit:10;}.font1{stroke:#04246a;}.content1{stroke:#e20101;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "font1",
    d: "M14.4,7.2A7.2,7.2,0,1,1,7.2,0,7.2,7.2,0,0,1,14.4,7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content1",
    d: "M0,4.759A4.759,4.759,0,0,1,4.759,0",
    transform: "translate(2.596 2.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "font1",
    d: "M5.4,5.4,0,0",
    transform: "translate(12.6 12.6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.4a1fb894807f46250e1eb4735eb9edec.svg";
export { ForwardRef as ReactComponent };